import { render, staticRenderFns } from "./SocialMediaAreaFoerderApp.vue?vue&type=template&id=0c87d697&scoped=true"
import script from "./SocialMediaAreaFoerderApp.vue?vue&type=script&lang=ts"
export * from "./SocialMediaAreaFoerderApp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c87d697",
  null
  
)

export default component.exports